<template>
	<div class="ai_container" style="height:100dvh !important">
		<div class="search_car_wrapper" style="height:100%">
			<div class="contents" style="height:100%">
				<iframe id="FD_EST_FRAME" name="FD_EST_FRAME" frameborder="0" width="100%" height='100%' style="background-color:#FFFFFF;" src=""></iframe>
			</div>
			<Alert
				:isVisible="isOpenAlert"
				:title="alert.title"
				:primaryText="alert.primaryText"
				:onClickPrimary="handleAlertClose"
			/>
			<Alert
				:isVisible="isDatAlert"
				:title="'시스템 점검중입니다'"
				:primaryText="'돌아가기'"
				:onClickPrimary="handleAlertClose"/>
			<div id="loading">
				<div class="car"></div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'
import Utils from '@/modules/utils'
import Alert from '../../components/ai/AiAlert.vue'

export default {
	name: 'AiUpload',
	components: {
		AppConfig,
		Utils,
		Alert
	},
	data() {
		return {
			isOpenAlert:false,
			isDatAlert:false,
			alert:{
				title:'',
				primaryText:'',
				content:''
			},
		}
	},
	computed: {
		customerNumber() {
			return this.$route.params.customerNumber; // 선택적 파라미터에 접근
		},
		vinNo(){
			const aiVinNo = Vue.$sessionStorage.get('aiVinNo')
			if(aiVinNo){
				return aiVinNo;
			} else {
				this.$router.push({name:'AiSearchCar'})
			}
		},
		carNo(){
			const aiCarNo = Vue.$sessionStorage.get('aiCarNo')
			if(aiCarNo){
				return aiCarNo;
			} else {
				this.$router.push({name:'AiSearchCar'})
			}
		},
		channel(){
			return Vue.$sessionStorage.get('aiChannel')
		}
	},

	methods: {
		receiveMessage(e) {
			if(e.source.name =='FD_EST_FRAME' && !Utils.isEmpty(e.data.contractId)){
				window.removeEventListener('message', this.receiveMessage);
				//this.saveVinSearchLog("Y", e.data.contractId);
			} else if(e.source.name =='FD_EST_FRAME' && (e.data.success == "fail" || e.data.success == "light")){
				//this.saveVinSearchLog(e.data.success == "fail" ? "N" : "L", "");
				var iframe = document.getElementById('FD_EST_FRAME');
	            if (iframe) {
	                iframe.parentNode.removeChild(iframe); // iframe 삭제
	            }
				this.alert.title=`죄송하지만 현재 고객님의 차량은\nAI견적 산출이 불가합니다.\n불편을 끼쳐드려 죄송하며, 문의 사항이 있으시면\n고객센터로 문의 부탁드립니다.\n\n감사합니다.`
				this.alert.primaryText='돌아가기'
				this.isOpenAlert = true;
				return false;
			} else {
				return;
			}

			$('#loading').show()

			let paramDatas = {
				datEstimateNo : e.data.contractId ,
				customerNumber : this.customerNumber,
				carNo : this.carNo,
				channel : this.channel
			};

			this.getContract(paramDatas);

			// this.$router.push({name: "AiLoading", params : response.data.result});

		},

		async getContract(paramDatas){
			Vue.httpClient
			.post('/m/ai/dat/estimate/getContract', paramDatas)
			.then((response) => {
				if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
					this.$router.push({name: "AiLoading", params : response.data.result});
				} else {
					this.fnErrorHandler("");
				}
			})
			.catch((error) => {
				this.fnErrorHandler("");
			})
			.finally(() => {
				$('#loading').hide()
			})
		},

		handleAlertClose(){
			this.$router.push({ name: 'AiMain' })
		},

		fnErrorHandler(error){
			this.alert.title=`오류가 발생하였습니다.\n잠시 후 다시 이용해주시기 바랍니다.`
			this.alert.primaryText='돌아가기'
			this.isOpenAlert = true;

			return false;
		},

	    saveVinSearchLog(successGubun, contractId){
			Vue.httpClient
			.post('/wage/vinSearchLog', {"searchGubun":"A",
				"successGubun" : successGubun,
				"vinNo" : this.vinNo,
				"datSeq" : contractId
			})
			.then((response) => {
				if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
					console.log("vin_search_log_success");
				} else {
					console.log("vin_search_log_fail");
				}
			})
			.catch((error) => {
				if (!_.isEmpty(error.result) && !_.isEmpty(error.result.status)) {
					console.log("vin_search_log"+error.result);
				} else if (!_.isEmpty(error.data) && !_.isEmpty(error.data.status)) {
					console.log("vin_search_log"+error.data);
				} else {
					console.log("vin_search_log=error");
				}
			});
    	}
		
	},
	mounted() {
		window.addEventListener('message', this.receiveMessage);

		this.$nextTick(function() {
			Vue.httpClient
			.post('/m/ai/datCheck')
			.then(response => {
				if(response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS){

					// dat 상태 Y이면 create
					Vue.httpClient
					.post('/m/ai/dat/estimate/create', {customerNumber : this.customerNumber})
					.then((response) => {
						if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
							if ( response.data.result != undefined ) {

								let result = response.data.result;
								var datResponseToken = result.datResponseToken.replace(/\"/gi,"");
								var hrefParam = 'datResponseToken='+datResponseToken+'&vinNo='+this.vinNo;
								FD_EST_FRAME.location.href = "/static/html/ai/upload.html?"+hrefParam;
							} else {
								throw new Error(response);
							}
						} else {
							throw new Error(response);
						}
					})
					.catch((error) => {
						this.fnErrorHandler(error);
					});
				} else {
					throw new Error('')
				}
			}).catch((e)=>{
				this.isDatAlert=true;
			})
		});
	},

	beforeDestroy() {
		window.removeEventListener('message', this.receiveMessage);
	},
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/ai/AiUpload.vue